/*!
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

export const VERSIONS_CONFIG = {
  aDevVersionsLinkPattern: 'https://{{prefix}}{{version}}angular.dev',
  aioVersions: [
    {
      version: 'v18',
      url: 'https://v18.angular.dev/overview',
    },
    {
      version: 'v17',
      url: 'https://v17.angular.io/docs',
    },
    {
      version: 'v16',
      url: 'https://v16.angular.io/docs',
    },
    {
      version: 'v15',
      url: 'https://v15.angular.io/docs',
    },
    {
      version: 'v14',
      url: 'https://v14.angular.io/docs',
    },
    {
      version: 'v13',
      url: 'https://v13.angular.io/docs',
    },
    {
      version: 'v12',
      url: 'https://v12.angular.io/docs',
    },
    {
      version: 'v11',
      url: 'https://v11.angular.io/docs',
    },
    {
      version: 'v10',
      url: 'https://v10.angular.io/docs',
    },
    {
      version: 'v9',
      url: 'https://v9.angular.io/docs',
    },
    {
      version: 'v8',
      url: 'https://v8.angular.io/docs',
    },
    {
      version: 'v7',
      url: 'https://v7.angular.io/docs',
    },
    {
      version: 'v6',
      url: 'https://v6.angular.io/docs',
    },
    {
      version: 'v5',
      url: 'https://v5.angular.io/docs',
    },
    {
      version: 'v4',
      url: 'https://v4.angular.io/docs',
    },
    {
      version: 'v2',
      url: 'https://v2.angular.io/docs',
    },
  ],
};
